import { useEffect, useRef, useState } from "react";
import { ReactMediaRecorder } from "react-media-recorder";
import $ from "jquery";
import Swal from "sweetalert2";
var interval = null;

export default function VideoRecording(props) {
    const [resume, setResume] = useState(false);
    const [mode, setMode] = useState("");

    useEffect(() => {
        if (props.captureMode === "Screen") {
            setMode("Screen")
        }
        else {
            setMode("Camera")
        }
        setTimeout(() => {
            $("#btnRecord").trigger('click');
        }, 1000)

    }, [props.captureMode])

    const VideoPreview = ({ stream, isPaused }) => {
        const videoRef = useRef(null);

        useEffect(() => {
            if (videoRef.current && stream) {
                videoRef.current.srcObject = stream;
            }
        }, [stream]);
        if (!stream) {
            return null;
        }
        return (
            <video
                ref={videoRef}
                width="100%"
                autoPlay={isPaused}
                style={{
                    height: "70vh",
                    border: "1px solid #CECECE",
                    borderRadius: "16px",
                    objectFit: "cover",
                }}
            />
        );
    };

    if (!mode) {
        return <span />
    }

    let inputProps = {};
    if (mode === "Camera") {
        inputProps = {
            video: true
        }
    }

    if (mode === "Screen") {
        inputProps = {
            screen: true
        }
    }

    return <ReactMediaRecorder
        {...inputProps}
        onStop={(blobUrl, blob) => {
            
            props.onStop(blobUrl, blob);
        }}
        render={({ status, startRecording, stopRecording,
            pauseRecording, resumeRecording,
            previewStream, isAudioMuted, muteAudio, unMuteAudio }) => (
            <div className="relative" style={{
                height: "70vh",
            }}>
                <VideoPreview
                    stream={previewStream}
                    isPaused={!resume}
                    style={{
                        height: "70vh",
                        border: "1px solid #CECECE",
                        borderRadius:
                            "16px",
                    }}
                />

                <button id="btnRecord" style={{ visibility: "hidden" }} onClick={startRecording}>Start Recording</button>
                <div className="absolute bottom-[20px] left-[45%] flex flex-row">
                    <a
                        style={{ opacity: isAudioMuted ? 0.4 : 1 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (isAudioMuted) {
                                unMuteAudio();
                            }
                            else {
                                muteAudio();
                            }
                        }}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_4827_36183)">
                                <rect x="4" width="32" height="32" rx="16" fill="white" fill-opacity="0.8" shape-rendering="crispEdges" />
                                <path d="M25.25 15.25C25.25 18.1495 22.8995 20.5 20 20.5M20 20.5C17.1005 20.5 14.75 18.1495 14.75 15.25M20 20.5V23.5M20 23.5H17M20 23.5H23M20 17.5C18.7574 17.5 17.75 16.4926 17.75 15.25V10.75C17.75 9.50736 18.7574 8.5 20 8.5C21.2426 8.5 22.25 9.50736 22.25 10.75V15.25C22.25 16.4926 21.2426 17.5 20 17.5Z" stroke="#111827" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_d_4827_36183" x="0" y="0" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset dy="4" />
                                    <feGaussianBlur stdDeviation="2" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4827_36183" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4827_36183" result="shape" />
                                </filter>
                            </defs>
                        </svg>
                    </a>
                    <a
                        style={{ opacity: resume ? 0.4 : 1 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setResume(!resume);
                            if (resume) {
                                pauseRecording();
                            }
                            else {
                                resumeRecording()
                            }
                        }} >
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_4827_36184)">
                                <rect x="4" width="32" height="32" rx="16" fill="white" fill-opacity="0.8" shape-rendering="crispEdges" />
                                <path d="M18.5 13.75V18.25M21.5 13.75V18.25M26.75 16C26.75 19.7279 23.7279 22.75 20 22.75C16.2721 22.75 13.25 19.7279 13.25 16C13.25 12.2721 16.2721 9.25 20 9.25C23.7279 9.25 26.75 12.2721 26.75 16Z" stroke="#111827" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_d_4827_36184" x="0" y="0" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset dy="4" />
                                    <feGaussianBlur stdDeviation="2" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4827_36184" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4827_36184" result="shape" />
                                </filter>
                            </defs>
                        </svg>
                    </a>
                    <a onClick={(e) => {
                        e.stopPropagation();
                        Swal.fire({
                            title: "Stop Recording",
                            text: "Are you sure want to stop recording",
                            icon: "question",
                            showCancelButton: true,
                            cancelButtonColor: "#d33",
                            showConfirmButton: true,
                            cancelButtonText: "Close",
                            confirmButtonText: "Yes",
                            customClass: {
                                cancelButton: "order-1 right-gap",
                                confirmButton: "order-2",
                                denyButton: "order-3",
                            },
                        }).then((x) => {
                            if (x.isConfirmed) {
                                stopRecording();
                            }
                        })

                    }} >
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_4827_36185)">
                                <rect x="4" width="32" height="32" rx="16" fill="white" fill-opacity="0.8" shape-rendering="crispEdges" />
                                <path d="M26.75 16C26.75 19.7279 23.7279 22.75 20 22.75C16.2721 22.75 13.25 19.7279 13.25 16C13.25 12.2721 16.2721 9.25 20 9.25C23.7279 9.25 26.75 12.2721 26.75 16Z" stroke="#F51010" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M17.75 14.5C17.75 14.0858 18.0858 13.75 18.5 13.75H21.5C21.9142 13.75 22.25 14.0858 22.25 14.5V17.5C22.25 17.9142 21.9142 18.25 21.5 18.25H18.5C18.0858 18.25 17.75 17.9142 17.75 17.5V14.5Z" stroke="#F51010" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_d_4827_36185" x="0" y="0" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset dy="4" />
                                    <feGaussianBlur stdDeviation="2" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4827_36185" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4827_36185" result="shape" />
                                </filter>
                            </defs>
                        </svg>
                    </a>
{/* 
                    {
                        props.captureMode === "Both" &&
                        <a onClick={() => {
                            pauseRecording();
                            mode === "Camera" ?
                                setMode("Screen") :
                                setMode("Camera");

                            setTimeout(() => {
                                startRecording();
                            }, 1000)
                        }}>
                            <svg width="40" height="40" viewBox="0 0 40 40"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.59375 17.125L7.75 20.5L6.625 21.625H15.625L14.5 20.5L13.6562 17.125M1 12.625H21.25M3.25 17.125H19C20.2426 17.125 21.25 16.1176 21.25 14.875V3.625C21.25 2.38236 20.2426 1.375 19 1.375H3.25C2.00736 1.375 1 2.38236 1 3.625V14.875C1 16.1176 2.00736 17.125 3.25 17.125Z"
                                    stroke="black"
                                    stroke-opacity="0.3"
                                    stroke-width="1.6875"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </a>
                    } */}

                    <a onClick={(e) => {
                        e.stopPropagation();
                        Swal.fire({
                            title: "Restart Recording",
                            text: "Are you sure want to restart the recording",
                            icon: "question",
                            showCancelButton: true,
                            cancelButtonColor: "#d33",
                            showConfirmButton: true,
                            cancelButtonText: "Close",
                            confirmButtonText: "Yes",
                            customClass: {
                                cancelButton: "order-1 right-gap",
                                confirmButton: "order-2",
                                denyButton: "order-3",
                            },
                        }).then((x) => {
                            if (x.isConfirmed) {
                                props.onRestart();
                            }
                        })

                    }} >
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_4827_36186)">
                                <rect x="4" width="32" height="32" rx="16" fill="white" fill-opacity="0.8" shape-rendering="crispEdges" />
                                <path d="M14 10V13.75H14.4361M25.9536 15.25C25.5845 12.2903 23.0597 10 20 10C17.482 10 15.3262 11.5511 14.4361 13.75M14.4361 13.75H17.75M26 22V18.25H25.5639M25.5639 18.25C24.6738 20.4489 22.518 22 20 22C16.9403 22 14.4155 19.7097 14.0464 16.75M25.5639 18.25H22.25" stroke="#111827" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_d_4827_36186" x="0" y="0" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset dy="4" />
                                    <feGaussianBlur stdDeviation="2" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4827_36186" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4827_36186" result="shape" />
                                </filter>
                            </defs>
                        </svg>
                    </a>

                </div>
            </div>
        )}
    />
}